import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAlertTriangle16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M8 2L1 13.9H15L8 2ZM8 2L1 13.9H15L8 2Z" stroke="currentColor" strokeMiterlimit={10} /><path d="M8 5.5V10.0589" stroke="currentColor" strokeMiterlimit={10} /><path d="M7.99996 12.4213C8.42171 12.4213 8.7636 12.0794 8.7636 11.6577C8.7636 11.2359 8.42171 10.894 7.99996 10.894C7.57822 10.894 7.23633 11.2359 7.23633 11.6577C7.23633 12.0794 7.57822 12.4213 7.99996 12.4213Z" fill="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgAlertTriangle16);
export default ForwardRef;